import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

const Demo = () => {
  return (
    <Layout>
      <Helmet>
        <title>Demo | RedERP</title>
        <meta
          name="description"
          content="Watch RedERP in action. Discover how our ERP, CRM, and eCommerce platform streamlines operations for businesses like yours."
        />
      </Helmet>

      {/* Hero / Header */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white py-28 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">See RedERP in Action</h1>
          <p className="text-lg text-white/80">
            Watch our product demo to explore the features, interface, and real use cases of RedERP.
          </p>
        </div>
      </section>

      {/* Demo Video */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.youtube.com/embed/SXFwLFZ6Gmg?rel=0&modestbranding=1"
              title="RedERP Demo"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full rounded-xl"
              style={{ border: "none", height: "500px" }}
            ></iframe>
          </div>
        </div>
      </section>

      {/* Key Takeaways */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-primary mb-6">What You'll Learn</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-left text-sm">
            <div className="bg-white p-6 rounded-xl shadow border border-gray-100">
              <h3 className="font-semibold text-primary mb-2">All-in-One Platform</h3>
              <p>How RedERP unifies Sales, Inventory, Finance, and CRM into one modern interface.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow border border-gray-100">
              <h3 className="font-semibold text-primary mb-2">Real-Time Dashboards</h3>
              <p>Visualize KPIs, revenue, orders, and more with powerful reporting tools.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow border border-gray-100">
              <h3 className="font-semibold text-primary mb-2">Unlimited Access</h3>
              <p>Learn how you can empower your entire team — with no user limits or hidden fees.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white text-center">
        <div className="max-w-xl mx-auto px-6">
          <h3 className="text-3xl font-bold mb-4">Start Your Free Trial</h3>
          <p className="mb-6">Try RedERP today — no credit card required.</p>
          <a
            href="https://app.rederp.pro/sign-up"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
          >
            Get Started for $5/month
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default Demo;
